/** @internal */
// @ts-ignore
export const MatchType = {
    Unknown: 0,
    Property: 1,
    PostalCode: 2,
    City: 3,
    BuildingName: 4,
    Submarket: 5,
    Street: 6,
    ResearchMarket: 7,
    Contact: 8,
    Company: 9,
    County: 10,
    Subdivision: 11,
    GeocodeResult: 12,
    BuildingPark: 13,
    ShoppingCenter: 14,
    Country: 15,
    PostalCodeGroup: 16,
    Region: 17,
    StoreType: 18,
    TransitStation: 19,
    PropertyResidential: 20,
    MultifamilyProperty: 21,
    Airport: 22,
    HotelName: 23,
    TransitStation2: 24,
    Military: 25,
    University: 26,
    StoreBrand: 27,
    GoogleResults: 28,
    PropertyManagers: 29,
    SearchEngineOptimization: 30,
    Metro: 31,
    SaleCompID: 32,
    SubmarketCluster: 34,
    MSA: 35,
    PropertyGroup: 36,
    CompEntity: 50,
    Comp: 51,
    ForSale: 52,
    ContactSaleComp: 81,
    ContactShoppingCenter: 82,
    ContactLeaseDeal: 83,
    ContactTenant: 84,
    ContactProperty: 85,
    SubscriptionContact: 86,
    CompanySaleComp: 91,
    CompanyShoppingCenter: 92,
    CompanyLeaseDeal: 93,
    StreetIntersection: 131,
    CoStarMarket: 132,
    TrueCity: 133,
    CensusRegion: 134,
    Continent: 135,
    Subcontinent: 136,
    Fund: 137,
    CompanyFund: 138,
    RetailBrand: 139,
    Tenant: 140,
    TenantCompany: 141,
    PostalCodeGlobal: 142
};
/** @internal */
// @ts-ignore
export const SearchType = {
    EntityCountProperty: 0,
    EntityCountForLease: 1,
    EntityCountForSale: 2,
    EntityCountLeaseComp: 3,
    EntityCountSaleComp: 4,
    EntityCountTenant: 5
};
/** @internal */
// @ts-ignore
export const PropertyType = {
    None: 0,
    Hospitality: 1,
    Industrial: 2,
    Land: 3,
    Unknown: 4,
    Office: 5,
    GeneralRetail: 6,
    Flex: 7,
    SportsEntertainment: 8,
    MixedUse: 9,
    Specialty: 10,
    Multifamily: 11,
    Healthcare: 13,
    Residential: 15
};
